module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mehinaku")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "head02",
    attrs: {
      "id": "fm_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#fm2"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#t_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  1. Whoops that signal social and natural events")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5#t_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2. Categories of speech")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter8#t_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3. Differences between possessed and unpossessed forms of Mehinaku")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter9#t_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4. Mehinaku extramarital affairs, 1972")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#t_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5. Everyday Mehinaku adornment")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#t_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6. Everyday oils, pigments, and designs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#t_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7. The meaning of Mehinaku adornment")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#t_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8. Terms used in greeting kinsmen and in-laws")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#t_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9. The meaning of Mehinaku greetings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#t_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Inventory of the possessions of one of the wealthiest villagers")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#t_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Age and craft skills")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#t_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Height and social participation of the adult Mehinaku men")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#t_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Witches and some of their methods")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#t_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Accusations of witchcraft by thirteen Mehinaku adults")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#t_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Periods of seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#t_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Activities in seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#t_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Symbols of seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#t_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Classes of food relevant to seclusion taboos")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#t_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The prohibition of fish, monkey, and bird meat in seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#t_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. A continuum of possible relationships between kinsmen and nonkinsmen")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab21"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#t_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The depth and scope of Mehinaku kindreds")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#t_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Restrictions honored by fathers during their infants’ first year")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#t_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Circumlocutions used to avoid the names of affinal relatives")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "tab24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#t_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Xingu trade specialties and monopolies")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d2a985b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter02.vue
// module id = 72
// module chunks = 0